import { type FormConfig, type SelectOption } from '@acme/foundation';

type MainOptionsType = {
  nets: SelectOption[];
  cryptoCurrencies: SelectOption[];
};

type AddOptionsType = {
  countries: SelectOption[];
};

export const applicationOfferFormMainInfoConfig = (
  includeUnchangedFields: boolean = true,
  options: MainOptionsType
): FormConfig => ({
  id: 'create-application-form',
  includeUnchangedFields, // возвращаем все поля или только измененные
  controls: [
    {
      id: 'commissionAuthorizedOrganizationRUB',
      label: 'Комиссия уполномоченной организации, руб',
      type: 'number',
      read: (ctx: any) => ctx?.commissionAuthorizedOrganizationRUB || '',
      write: { path: 'commissionAuthorizedOrganizationRUB' },
    },
    {
      id: 'commissionAgentRUB',
      label: 'Комиссия агента, руб',
      type: 'number',
      read: (ctx: any) => ctx?.commissionAgentRUB || '',
      write: { path: 'commissionAgentRUB' },
      props: {
        placeholder: 'Напишите или вставьте контрагента',
      },
    },
    {
      id: 'agentCryptoAddress',
      label: 'Криптоадрес кошелька агента',
      type: 'text',
      read: (ctx: any) => ctx?.agentCryptoAddress || '',
      write: { path: 'agentCryptoAddress' },
      props: {
        placeholder: 'Напишите или вставьте криптоадрес',
      },
    },
    {
      id: 'agentWalletNetId',
      label: 'Сеть',
      type: 'select',
      read: (ctx: any) => ctx?.agentWalletNetId || '',
      write: { path: 'agentWalletNetId' },
      props: {
        placeholder: 'Выберите сеть',
      },
      options: {
        source: options.nets,
      },
    },
    {
      id: 'cryptoCurrencyId',
      label: 'Криптовалюта',
      type: 'select',
      read: (ctx: any) => ctx?.cryptoCurrencyId || '',
      write: { path: 'cryptoCurrencyId' },
      props: {
        placeholder: 'Выберите криптовалюту',
      },
      options: {
        source: options.cryptoCurrencies,
      },
    },
    {
      id: 'cryptoAmount',
      label: 'Сумма криптовалюты',
      type: 'text',
      read: (ctx: any) => ctx?.cryptoAmount || '',
      write: { path: 'cryptoAmount' },
    },
  ],
});

export const applicationOfferFormAddInfoConfig = (
  includeUnchangedFields: boolean = true,
  options: AddOptionsType
): FormConfig => ({
  id: 'create-application-form',
  includeUnchangedFields, // возвращаем все поля или только измененные
  controls: [
    {
      id: 'organizationName',
      label: 'Наименование организации',
      type: 'text',
      read: (ctx: any) => ctx?.organizationName || '',
      write: { path: 'organizationName' },
      props: {
        placeholder: 'Напишите или вставьте наименование',
      },
    },
    {
      id: 'senderCountryId',
      label: 'Страна отправителя',
      type: 'select',
      read: (ctx: any) => ctx?.senderCountryId || '',
      write: { path: 'senderCountryId' },
      props: {
        placeholder: 'Выберите страну',
      },
      options: {
        source: options.countries,
      },
    },
    {
      id: 'bankName',
      label: 'Название банка',
      type: 'text',
      read: (ctx: any) => ctx?.bankName || '',
      write: { path: 'bankName' },
      props: {
        placeholder: 'Напишите или вставьте название банка',
      },
    },
  ],
});
